import { render, staticRenderFns } from "./phoneList.vue?vue&type=template&id=3d4976a0"
import script from "./phoneList.vue?vue&type=script&lang=js"
export * from "./phoneList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports